import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input, Spinner } from 'reactstrap'
// import axios from 'axios';
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate, MdWarning } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import { MDBDataTableV5, MDBDataTable, MDBIcon } from 'mdbreact'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'
import '@fortawesome/fontawesome-free/css/all.min.css'
import { getProductCategory_v2 } from '../utils/dropdownlist'
import PosCategoryForm from '../components/PosCategoryForm'
import PosListOrderForm from '../components/PosListOrderForm'
import PosShowInMenuForm from '../components/PosShowInMenuForm'
import PosDeleteSelectedForm from '../components/PosDeleteSelectedForm'
import { CSVLink } from 'react-csv'
import { toObjectLowerCase } from '@syncfusion/ej2-react-richtexteditor'

const headers = [
  {
    label: 'Product No.',
    key: 'product_no',
  },
  {
    label: 'Name',
    key: 'name',
  },
  {
    label: 'Category',
    key: 'category',
  },
  {
    label: 'Type',
    key: 'product_type',
  },
  {
    label: 'Price',
    key: 'Price',
  },
]

const tbcolumn = [
  {
    label: <input type="checkbox" />,
    field: 'checkbox',
    sort: 'disabled',
    width: 100,
  },
  {
    label: 'Product No.',
    field: 'product_no',
    //sort: 'asc',
    width: 120,
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
    width: 120,
  },
  {
    label: 'Category',
    field: 'category',
    sort: 'asc',
    width: 120,
  },
  {
    label: 'Type',
    field: 'product_type',
    sort: 'asc',
    width: 120,
  },
  {
    label: 'List Order',
    field: 'list_order',
    sort: 'asc',
    width: 120,
  },
  {
    label: 'Show In Menu',
    field: 'Default_List',
    sort: 'asc',
    width: 120,
  },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
    width: 120,
  },
]

class PosProductTable extends React.Component {
  _isMounted = true
  sortKey = sessionStorage.getItem('sortKey')
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      infoModal: false,
      categoryModal: false,
      listorderModal: false,
      isLoading: true,
      productLoading: true,
      productList: [],
      filterList: [],
      categoryList: [],
      selectedId: '',
      selectedData: '',
      redirect: false,
      sortKey: this.sortKey ? this.sortKey : '',
      bulkDelete: false,
      isall: false,
      checkedRows: [],
      showinmenuModal: false,
      deleteselectedModal: false,
      order: ['product_no', 'desc'],
    }
    this.getProductCategory = this.getProductCategory.bind(this)
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.categoryList !== state.categoryList) {
      return {
        categoryList: props.data.categoryList,
      }
    }
    return null
  }

  changeHandler = event => {
    const { name, value } = event.target
    this.setState({
      [name]: value,
    })

    if (name === 'sortKey') {
      sessionStorage.setItem('sortKey', value)
    }
  }

  handleOnSort = value => {
    console.log(value)
    const { column, direction } = value
    this.setState({
      order: ['product_no', 'desc'],
    })

    // if (name === 'sortKey') {
    //   sessionStorage.setItem('sortKey', value)
    // }
  }

  // sortData() {
  //   const { productList, sortKey } = this.state;
  //   if (sortKey.length) {
  //     productList.sort((a, b) => a[sortKey] - b[sortKey]).reverse();
  //     this.setState({ productList });
  //   } else {
  //     this.getProductList();
  //   }
  // }

  CsvNotFound() {
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: 'Data Not Found',
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    })
  }

  filterData() {
    const { productList, sortKey } = this.state
    if (sortKey.length) {
      let item = productList.filter(x => x.category === sortKey)
      this.setState({ filterList: item }, () => this.custData('filter', item))
    } else {
      this.setState({ filterList: productList }, () => this.custData('filter', productList))
    }

    this.setState({
      bulkDelete: false,
      isall: false,
      checkedRows: [],
    })
  }

  getProductList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3002/v1/product', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        return result.data
        // if (result.data.length > 0) {
        //   for (let i of result.data) {
        //     i.Default_List = <span className={'ps-indicator ' + (i.default_list == '1' ? 'on' : 'off')}>{i.default_list == '1' ? 'Yes' : 'No'}</span>

        //     i.checkbox = (
        //       <Input
        //         type="checkbox"
        //         name={i.id}
        //         checked={this.state.checkedRows.some(j => j == i.id)}
        //         onChange={e => {
        //           this.handleCheck(e, false)
        //         }}
        //       />
        //     )

        //     i.Action = (
        //       <div className="ps-action-button">
        //         <Button className="theme-button theme-button-secondary" onClick={() => this.product(true, i.id)}>
        //           View
        //         </Button>
        //         <Button className="theme-button theme-button-primary-light" onClick={this.infoModal(i.id)}>
        //           Info
        //         </Button>
        //       </div>
        //     )
        //   }
        // }

        // if (this._isMounted) {
        //   let item = result.data
        //   if (this.sortKey) {
        //     item = result.data.filter(x => x.category === this.sortKey)
        //   }
        //   this.setState({
        //     productLoading: false,
        //     productList: result.data,
        //     filterList: item,
        //   })
        // }
      })
      .then(data => {
        this.custData('api', data)
      })
      .catch(error => {
        alert(error)
      })
  }

  custData(method, data) {
    tbcolumn[0].label = (
      <Input
        type="checkbox"
        checked={this.state.bulkDelete}
        onChange={e => {
          this.handleCheckHeader(e, true)
        }}
      />
    )

    for (let i of data) {
      i.Default_List = <span className={'ps-indicator ' + (i.default_list == '1' ? 'on' : 'off')}>{i.default_list == '1' ? 'Yes' : 'No'}</span>

      i.checkbox = (
        <Input
          type="checkbox"
          name={i.id}
          checked={this.state.checkedRows.some(j => j == i.id)}
          onChange={e => {
            this.handleCheckItem(e, false)
          }}
        />
      )

      i.Price = i.price_data.length ? JSON.parse(i.price_data)[0].price : ''

      i.Action = (
        <div className="ps-action-button">
          <Button className="theme-button theme-button-secondary" onClick={() => this.product(true, i.id)}>
            View
          </Button>
          <Button className="theme-button theme-button-primary-light" onClick={this.infoModal(i.id)}>
            Info
          </Button>
        </div>
      )
    }

    if (this._isMounted) {
      let item = data
      if (this.state.sortKey) {
        item = this.state.sortKey == '' ? this.state.productList : data.filter(x => x.category === this.state.sortKey)
      }
      this.setState({
        productLoading: false,
        productList: method == 'api' ? data : this.state.productList,
        filterList: item,
      })
    }
  }

  getProductCategory() {
    getProductCategory_v2()
      .then(result => {
        if (this._isMounted) {
          if (result.error == true && result.message != 'Success') {
            alert(result.message)
            return
          }
          this.setState({
            isLoading: false,
            categoryList: result.data.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  componentDidMount() {
    this.getProductList()
    this.getProductCategory()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  toggle = (action, id) => () => {
    return this.setState({
      categoryModal: !this.state.categoryModal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleListOrder = () => () => {
    return this.setState({
      listorderModal: !this.state.listorderModal,
    })
  }

  toggleShowInMenu = () => () => {
    return this.setState({
      showinmenuModal: !this.state.showinmenuModal,
    })
  }

  toggleDeleteSelected = () => () => {
    console.log('delete')
    return this.setState({
      deleteselectedModal: !this.state.deleteselectedModal,
    })
  }

  handleCheck = (e, isall) => {
    let checkedRows = []
    if (isall) {
      if (e.target.checked) {
        for (let i of this.state.filterList) {
          checkedRows.push(i.id)
        }
      } else checkedRows = []
    } else {
      checkedRows = [...this.state.checkedRows]
      if (e.target.checked) checkedRows.push(e.target.name)
      else checkedRows.splice(checkedRows.indexOf(e.target.name), 1)
    }
    this.setState(
      {
        checkedRows,
        bulkDelete: isall ? (e.target.checked ? true : false) : false,
      },
      () => this.custData('check', this.state.filterList),
    )
  }

  handleCheckHeader = (e, isall) => {
    let checkedRows = []

    if (e.target.checked) {
      for (let i of this.state.filterList) {
        checkedRows.push(i.id)
      }
    } else checkedRows = []

    this.setState(
      {
        checkedRows,
        bulkDelete: e.target.checked,
      },
      () => this.custData('check', this.state.filterList),
    )
  }

  handleCheckItem = e => {
    let { name } = e.target
    let id = parseInt(name)
    let checkedRows = []
    checkedRows = [...this.state.checkedRows]
    if (e.target.checked) checkedRows.push(id)
    else checkedRows.splice(checkedRows.indexOf(id), 1)
    this.setState(
      {
        checkedRows,
        //bulkDelete: isall ? (e.target.checked ? true : false) : false,
      },
      () => this.custData('check', this.state.filterList),
    )
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      categoryModal: false,
      listorderModal: false,
      showinmenuModal: false,
      deleteselectedModal: false,
      bulkDelete: false,
      checkedRows: [],
    })

    if (reload) {
      window.location.reload()
    } else {
      this.props.getCategoryList()
      this.getProductList()
    }
  }

  product = (isEdit, id) => {
    if (!this.state.isLoading) {
      if (this.state.categoryList.length > 0) {
        this.props.history.push({
          pathname: '/posproduct/' + id,
          state: { isEdit },
        })
      } else {
        this.setState({
          categoryModal: !this.state.categoryModal,
          isEdit: false,
          selectedId: '',
        })
      }
    }
  }

  infoModal = product_id => () => {
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      product_id: product_id,
    }

    axios
      .post(url + ':3002/v1/product/instore', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            infoModal: true,
            product_data: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    const data = {
      columns: tbcolumn,
      rows: this.state.filterList,
    }
    console.log(this.state.filterList)
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <Row>
          <Col md={8}>
            <Row>
              <Label className="text-center" for="sortBy" sm={2}>
                Category
              </Label>

              <Col sm={4}>
                <Input className="ps-input-small" type="select" name="sortKey" value={this.state.sortKey} onChange={this.changeHandler}>
                  <option value="">Default</option>
                  {this.state.categoryList.map(item => {
                    return <option key={item.id}>{item.name}</option>
                  })}
                </Input>
              </Col>
              <Col sm={2}>
                <Button
                  className="theme-button theme-button-dark"
                  onClick={() => {
                    this.filterData()
                  }}>
                  Filter
                </Button>
              </Col>
            </Row>
          </Col>

          <Col md={4}>
            <div className="text-right mb-4">
              <div className="ps-btn-group">
                <Button color="link" onClick={() => this.product(false, 'create')}>
                  <IconContext.Provider value={{ color: '#2a2c6b' }}>
                    <BsPlusSquareFill size={25} />
                  </IconContext.Provider>
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <div className="ps-action-button">
            <CSVLink
              data={this.state.productList}
              headers={headers}
              filename={'Product_List.csv'}
              onClick={() => {
                if (this.state.productList.length < 1) {
                  this.CsvNotFound()
                  return false
                }
              }}>
              <Button type="button" className="ps-input-small theme-button-primary">
                Export
              </Button>
            </CSVLink>
            <Button type="button" className="ps-input-small theme-button-primary" disabled={this.state.checkedRows.length > 0 ? false : true} onClick={this.toggleListOrder()}>
              Set List Order
            </Button>
            <Button type="button" className="ps-input-small theme-button-primary" disabled={this.state.checkedRows.length > 0 ? false : true} onClick={this.toggleShowInMenu()}>
              Set Show In Menu
            </Button>
            <Button type="button" className="ps-input-small theme-button-primary" disabled={this.state.checkedRows.length > 0 ? false : true} onClick={this.toggleDeleteSelected()}>
              Delete Selected
            </Button>
          </div>
        </Row>

        {this.state.productList.length > 0 ? (
          <MDBDataTable className="ps-product-table ps-mdb-table" order={this.state.order} data={data} entries={50} displayEntries={false} searchTop searchBottom={false} fullPagination disableRetreatAfterSorting={true} responsive onSort={value => this.handleOnSort(value)} />
        ) : (
          <Table responsive hover className="ps-table tb-col-8">
            <thead>
              <tr>
                <th>Product No.</th>
                <th>Name</th>
                <th>Category</th>
                <th>Type</th>
                <th>List Order</th>
                <th>Show In Menu</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {this.state.productLoading ? (
                <tr>
                  <td colSpan="7">
                    <div
                      style={{
                        minHeight: '100px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                      <Spinner animation="border" variant="primary" />
                    </div>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="7">
                    <div className="ps-empty-data">
                      <div className="empty-content">
                        <MdCreate />
                        <h4>No data to show</h4>
                        <span>Click the 'Create' button to add new product</span>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}

        <Modal isOpen={this.state.categoryModal} toggle={this.toggle()} className={this.props.className} centered>
          <PosCategoryForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.listorderModal} toggle={this.toggleListOrder()} className={this.props.className} centered>
          <PosListOrderForm history={this.props.history} onToggleModal={this.toggleListOrder} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.showinmenuModal} toggle={this.toggleShowInMenu()} className={this.props.className} centered>
          <PosShowInMenuForm history={this.props.history} onToggleModal={this.toggleShowInMenu} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.deleteselectedModal} toggle={this.toggleDeleteSelected()} className={this.props.className} centered>
          <PosDeleteSelectedForm history={this.props.history} onToggleModal={this.toggleDeleteSelected} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal
          isOpen={this.state.infoModal}
          toggle={() => {
            this.setState({
              infoModal: false,
            })
          }}
          className={this.props.className}
          centered>
          <ModalHeader>Product Info</ModalHeader>
          <ModalBody>
            <Table responsive hover className="ps-table tb-col-4">
              <thead>
                <tr>
                  <th>Store Code</th>
                  <th>Name</th>
                  <th>Price Data</th>
                  <th>Quantity Data</th>
                </tr>
              </thead>
              <tbody>
                {this.state.product_data &&
                  this.state.product_data.length > 0 &&
                  this.state.product_data.map((item, index) => {
                    let price_data = JSON.parse(item.price_data)
                    let qty_data = JSON.parse(item.qty_data)

                    return (
                      <tr key={index}>
                        <td>{item.store_code}</td>
                        <td>{item.name}</td>
                        <td>{price_data[0].price + ' / ' + price_data[0].unit}</td>
                        <td>{qty_data[0].unit + ' / ' + qty_data[0].qty}</td>
                      </tr>
                    )
                  })}
              </tbody>
            </Table>
          </ModalBody>
        </Modal>
      </>
    )
  }
}
export default PosProductTable
